export default __webpack_public_path__ + "static/media/DefinixIcon-14.d8201945.png";